<mat-selection-list id="metric-list">
  <span *ngFor="let option of displayedMetrics">
    <div *ngIf="option.preGroupText" class="pregroup">{{option.preGroupText}}</div>
    <mat-checkbox [checked]="option.selected" (click)="whenOptionSelected(option, $event)"
                  class="option-box">{{option.text}}</mat-checkbox>
  </span>
</mat-selection-list>
